import { render, staticRenderFns } from "./AudioAttachment.vue?vue&type=template&id=11070aac"
import script from "./AudioAttachment.vue?vue&type=script&lang=js"
export * from "./AudioAttachment.vue?vue&type=script&lang=js"
import style0 from "./AudioAttachment.vue?vue&type=style&index=0&id=11070aac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports